import { render, staticRenderFns } from "./orderFood.vue?vue&type=template&id=2b0d8c18&scoped=true"
import script from "./orderFood.vue?vue&type=script&lang=js"
export * from "./orderFood.vue?vue&type=script&lang=js"
import style0 from "./orderFood.vue?vue&type=style&index=0&id=2b0d8c18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0d8c18",
  null
  
)

export default component.exports